<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 75vh;">
    <p class="Titulo">Consulta - Área Componente</p>
      <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;" (click)="consultarAreaComponenteConsulta()">
        <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
      </button>
    <app-spinner *ngIf="showSpinnerConsulta"></app-spinner>
    <div *ngIf="showGrillaConsulta">
      <!-- <angular-slickgrid gridId="gridAreaComponenteConsulta" 
      [columnDefinitions]="columnDefinitionsAreaComponenteConsulta"
        [gridOptions]="gridOptionsAreaComponenteConsulta" 
        [dataset]="datasetAreaComponenteConsulta" 
        gridHeight="380"
        gridWidth="100%"
        (onAngularGridCreated)="angularGridReadyAreaComponenteConsulta($event)">
      </angular-slickgrid> -->
      <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetAreaComponenteConsulta"
            [columnDefs]="columnDefinitionsAreaComponenteConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
    </div>
    <button nbButton size="tiny" style="float: right; margin-top: 50px;" class=" buttontz" [hidden]="!showGrillaConsulta" [disabled]="!showGrillaConsulta"
            (click)="exportToExcelAreaComponente()" ><nb-icon icon="save-outline"></nb-icon>Exportar</button>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Alta" tabIcon="upload-outline" responsive style="height: 75vh;">
    <p class="Titulo">Alta Área Componente</p>
    <div class="row">
      <div class="col-4">
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Descripción</mat-label>
            <input matInput #message1 maxlength="80" [(ngModel)]="descripcionAreaComponente" name="descripcion">
            <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Descripción Breve</mat-label>
            <input matInput #message2 maxlength="40" [(ngModel)]="descripcionBreveComponente" name="breve">
            <mat-hint align="end">{{message2.value.length}} / 40</mat-hint>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="altaLabel">
            <mat-label>Ingresar Código Externo</mat-label>
            <input matInput #message3 maxlength="40" [(ngModel)]="codigoExternoComponente" name="codigo">
            <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
          </mat-form-field>
        </p>
        <div>
          <p-dropdown required 
            class="limited-selector" 
            id="inputComponente" 
            placeholder="Seleccionar Componente"
            [style]="{'width':'100%','margin-bottom':'10px'}" 
            [options]="componente"
            [(ngModel)]="componenteCompleto"
            [virtualScroll]="true" 
            [itemSize]="31" 
            [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
            [panelStyle]="{'bottom':'100%','top':'auto'}"
            >
          </p-dropdown>
        </div>
        <div>
          <p-dropdown required 
            class="limited-selector" 
            id="inputArea" 
            placeholder="Seleccionar Área"
            [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" 
            [options]="area"
            [(ngModel)]="areaProcesadaAlta"
            [virtualScroll]="true" 
            [itemSize]="31" 
            [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
            [panelStyle]="{'bottom':'100%','top':'auto'}"
            >
          </p-dropdown>
        </div>
        <p>
          <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
          <button  *ngIf="!showSpinnerGuardar" nbButton size="tiny" status="primary" class="buttontz" (click)="altaAreaComponente()">Guardar</button>
        </p>
      </div>
      <div>
        <button nbButton shape="round" size="small" class="buttontz float-right" (click)="consultarAreaComponente()">
          <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
        </button>
      </div>
      <app-spinner class="float-right col-6" *ngIf="showSpinner"></app-spinner>
      <div *ngIf="showGrilla" class="float-right col-6">
        <!-- <angular-slickgrid gridId="gridAreaComponente" [columnDefinitions]="columnDefinitionsAreaComponente"
          [gridOptions]="gridOptionsAreaComponente" [dataset]="datasetAreaComponente" gridHeight="380"
          (onAngularGridCreated)="angularGridReadyAreaComponente($event)">
        </angular-slickgrid> -->
        <ag-grid-angular
            #grilla2
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetAreaComponente"
            [columnDefs]="columnDefinitionsAreaComponente"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
      </div>
    </div>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Modificación" tabIcon="edit-outline" responsive style="height: 75vh;">
    <p class="Titulo">Modificar Área Componente</p>
    <div class="row">
      <div class="col-4 float-left">
      <div>
        <p-dropdown required 
            class="limited-selector" 
            id="inputAreaComponente" 
            placeholder="Seleccionar Área Componente"
            [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" 
            [options]="averiasAreaComponente"
            [(ngModel)]="areaComponenteSeleccionada" 
            (onChange)="obtenerDescripcionDropdown(areaComponenteSeleccionada)"
            [virtualScroll]="true" 
            [itemSize]="31" 
            [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
            
           >
        </p-dropdown>
      </div>
      <div>
        <mat-form-field class="altaLabelModificar">
          <mat-label>Descripcion</mat-label>
          <input matInput #message4 maxlength="80" [(ngModel)]="descripcionAreaEditarComponente"
          name="descripcionAreaEditarComponente">
          <mat-hint align="end">{{message4.value.length}} / 80</mat-hint>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="altaLabelModificar">
          <mat-label>Descripcion Breve</mat-label>
          <input matInput #message5 maxlength="40" [(ngModel)]="descripcionBreveEditarComponente"
          name="descripcionBreveEditarComponente">
          <mat-hint align="end">{{message5.value.length}} / 40</mat-hint>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="altaLabelModificar">
          <mat-label>Código Externo</mat-label>
          <input matInput #message6 maxlength="40" [(ngModel)]="codigoExternoEditarComponente"
          name="codigoExternoEditarComponente">
          <mat-hint align="end">{{message6.value.length}} / 40</mat-hint>
        </mat-form-field>
      </div>
      <div>
        <p-dropdown required class="limited-selector" 
          id="inputArea" 
          placeholder="Seleccionar Área"
          [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" 
          [options]="area"
          [(ngModel)]="areaProcesada"
          [virtualScroll]="true" 
          [itemSize]="31" 
          [filter]="true"
          [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
          [panelStyle]="{'bottom':'100%','top':'auto'}"
          >
        </p-dropdown>
      </div>
      <div>
        <p-dropdown required 
          class="limited-selector" 
          id="inputAreaComponente" 
          placeholder="Seleccionar Componente"
          [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" 
          [options]="componente"
          [(ngModel)]="componenteCompletoModificar"
          [virtualScroll]="true" 
          [itemSize]="31" 
          [filter]="true"
          [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
          [panelStyle]="{'bottom':'100%','top':'auto'}"
          >
        </p-dropdown>
      </div>
      <p>
        <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar</nb-checkbox>
      </p>
      <p>
        <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
        <button *ngIf="!showSpinnerModificar" nbButton size="tiny" status="primary" class="buttontz"
        (click)="modificarAreaComponente()">Modificar</button>
      </p>
    </div>
    <div class="col-6 float-right">
      <app-spinner class="float-right col-6" *ngIf="showSpinnerModificar"></app-spinner>
      <div *ngIf="showGrillaModificar">
        <!-- <angular-slickgrid gridId="gridAreaComponenteModificar" [columnDefinitions]="columnDefinitionsAreaComponenteModificar"
          [gridOptions]="gridOptionsAreaComponenteModificar" [dataset]="datasetAreaComponenteModificar" gridHeight="380"
          (onAngularGridCreated)="angularGridReadyAreaComponenteModificar($event)">
        </angular-slickgrid> -->
        <ag-grid-angular
            #grilla3
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetAreaComponenteModificar"
            [columnDefs]="columnDefinitionsAreaComponenteModificar"
            (gridReady)="onGridReady($event)" 
       
            [enableCellTextSelection]="true"/>
      </div>
    </div>
    </div>
  </nb-tab>
</nb-tabset>